import { apiFetch } from './api-client';
import type { LeaderboardResponse } from './leaderboard';
import { getActiveWorkspaceHeaders } from './workspace-context';

async function readJson<T>(response: Response, fallbackError: string): Promise<T> {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error((data as { error?: string }).error || fallbackError);
  }
  return data as T;
}

export async function fetchLeaderboard(scenarioId?: string | null): Promise<LeaderboardResponse> {
  const query = scenarioId ? `?scenario_id=${encodeURIComponent(scenarioId)}` : '';
  const response = await apiFetch(`/api/leaderboard${query}`, { headers: getActiveWorkspaceHeaders() });
  return readJson<LeaderboardResponse>(response, 'Impossible de charger le classement.');
}

export async function fetchPseudoSuggestion(): Promise<{ pseudo: string; color: string }> {
  const response = await apiFetch('/api/leaderboard/pseudo-suggestion');
  return readJson(response, 'Impossible de proposer un pseudo.');
}

/** Renvoie l'utilisateur à jour (à passer à `updateSession`). */
export async function savePlayerProfile<TUser>(pseudo: string, color: string): Promise<TUser> {
  const response = await apiFetch('/api/leaderboard/profile', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pseudo, color }),
  });
  const data = await readJson<{ user: TUser }>(response, "Impossible d'enregistrer le pseudo.");
  return data.user;
}

export async function resetPlayerProfile(userId: string): Promise<void> {
  const response = await apiFetch(`/api/leaderboard/admin/users/${encodeURIComponent(userId)}/profile`, {
    method: 'DELETE',
  });
  await readJson(response, 'Impossible de réinitialiser le pseudo.');
}
